import { Instagram, Video } from "lucide-react";
const LOGO_URL = "https://pdaaustralia.com.au/wp-content/uploads/2026/06/PDA_Australia_logo_transparent.png";
const exploreLinks = [{
  label: "Articles",
  href: "/articles/"
}, {
  label: "Free Resources",
  href: "/resources/"
}, {
  label: "Start Here",
  href: "/start-here/"
}];
const supportLinks = [{
  label: "Contact Us",
  href: "/contact-us/"
}, {
  label: "Disclaimer & Legal",
  href: "/disclaimer-legal/"
}];
const socialLinks = [{
  label: "Instagram",
  href: "https://www.instagram.com/pdaaustraliaau/",
  icon: Instagram
}, {
  label: "TikTok",
  href: "https://www.tiktok.com/@pdaaustraliaau",
  icon: Video
}];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer data-section-id="159790" id="footer-navigation" className="relative overflow-hidden bg-[#f6f1e9] px-4 py-10 text-[#163b3b] sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
       {/* Pre-footer CTA */}
<section aria-label="Guide library call to action" className="relative mb-6 overflow-hidden rounded-[2rem] bg-[#163b3b] px-6 py-8 shadow-[0_24px_58px_rgba(30,55,50,0.14)] md:px-10 md:py-11">
  <div className="pointer-events-none absolute -right-24 -top-28 h-72 w-72 rounded-full bg-white/10" />

  <div className="pointer-events-none absolute bottom-[-2.4rem] right-8 text-[8rem] font-black leading-none tracking-[-0.08em]" style={{
          color: "rgba(255,255,255,0.035)"
        }}>
    PDA
  </div>

  <div className="relative z-10 grid gap-8 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">
    <div>
      <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/35 bg-white/15 px-4 py-2 text-xs font-black uppercase tracking-[0.08em]" style={{
              color: "#ffffff"
            }}>
        <span className="h-2 w-2 rounded-full bg-[#d9572e]" />
        Need practical support?
      </div>

      <div role="heading" aria-level={2} className="mb-4 max-w-3xl text-4xl font-black leading-[1.02] tracking-[-0.05em] md:text-5xl" style={{
              color: "#ffffff"
            }}>
        Start free, then go deeper with the full guides
      </div>

      <div className="max-w-3xl text-lg leading-relaxed" style={{
              color: "rgba(255,255,255,0.86)"
            }}>
        Use the free resources for quick support. When you need step-by-step
        templates, scripts and a complete pathway, move into the PDA Australia
        paid guide library.
      </div>
    </div>

    <div className="flex flex-col gap-3 sm:flex-row lg:justify-end">
      <a href="/product/funded-ndis-guide-pda/" className="inline-flex min-h-12 items-center justify-center rounded-full bg-[#d9572e] px-6 py-3 text-center font-black shadow-[0_14px_25px_rgba(217,87,46,0.2)] transition hover:-translate-y-0.5 hover:bg-[#bc4725]" style={{
              color: "#ffffff"
            }}>
        NDIS Funding Guide
      </a>

      <a href="/start-here/" className="inline-flex min-h-12 items-center justify-center rounded-full border border-white/35 bg-white/10 px-6 py-3 text-center font-black transition hover:-translate-y-0.5 hover:bg-white/20" style={{
              color: "#ffffff"
            }}>
        Start Here
      </a>
    </div>
  </div>
</section>

        {/* Main footer */}
        <section aria-label="Footer links and legal information" className="overflow-hidden rounded-[2rem] border border-[#163b3b]/15 bg-[#fffdf8] shadow-[0_24px_58px_rgba(30,55,50,0.14)]">
          <div className="grid gap-9 px-6 py-8 md:grid-cols-2 md:px-10 md:py-10 lg:grid-cols-[1.45fr_0.72fr_0.9fr_0.78fr]">
            {/* Brand */}
            <div className="md:col-span-2 lg:col-span-1">
              <a href="/" aria-label="PDA Australia homepage" className="mb-5 block max-w-[320px]">
                <img src={LOGO_URL} alt="PDA Australia logo" className="h-auto w-full object-contain" />
              </a>

              <p className="max-w-md text-base leading-relaxed text-[#42524f]">
                <strong>
                  Practical PDA and autism resources for Australian families,
                  teachers and support teams.
                </strong>
              </p>

              <p className="mt-3 max-w-md text-sm leading-relaxed text-[#63706b]">
                Download free resources, read clear articles, or choose a full
                guide for home, school and NDIS planning.
              </p>
            </div>

            {/* Explore */}
            <nav aria-label="Explore PDA Australia">
              <h3 className="mb-4 text-sm font-black uppercase tracking-[0.08em] text-[#163b3b]">
                Explore
              </h3>

              <ul className="space-y-3">
                {exploreLinks.map(link => <li key={link.href}>
                    <a href={link.href} className="inline-flex items-center text-sm font-bold text-[#42524f] transition hover:translate-x-0.5 hover:text-[#d9572e]">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </nav>

            {/* Featured Guide */}
            <div>
              <h3 className="mb-4 text-center text-sm font-black uppercase tracking-[0.08em] text-[#163b3b] md:text-left lg:text-center">
                Featured Guide
              </h3>

              <div className="rounded-[1.6rem] border border-[#163b3b]/15 bg-gradient-to-b from-white to-[#fbf8f2] p-5 shadow-[0_14px_34px_rgba(30,55,50,0.10)]">
                <h3 className="mb-2 text-xl font-black leading-tight tracking-[-0.02em] text-[#163b3b]">
                  NDIS Funding Guide
                </h3>

                <p className="mb-4 text-sm leading-relaxed text-[#63706b]">
                  Templates, scripts and planning support for Australian PDA
                  families navigating NDIS funding.
                </p>

                <a href="/product/funded-ndis-guide-pda/" className="inline-flex min-h-11 items-center justify-center rounded-full bg-[#d9572e] px-5 py-3 text-sm font-black shadow-[0_14px_25px_rgba(217,87,46,0.18)] transition hover:-translate-y-0.5 hover:bg-[#bc4725]" style={{
                color: "#ffffff"
              }}>
  View Guide
</a>
              </div>
            </div>

            {/* Support, Legal, Socials */}
            <nav aria-label="Support, legal and social links">
              <h3 className="mb-4 text-sm font-black uppercase tracking-[0.08em] text-[#163b3b]">
                Support &amp; Legal
              </h3>

              <ul className="space-y-3">
                {supportLinks.map(link => <li key={link.href}>
                    <a href={link.href} className="inline-flex items-center text-sm font-bold text-[#42524f] transition hover:translate-x-0.5 hover:text-[#d9572e]">
                      {link.label}
                    </a>
                  </li>)}
              </ul>

              <h3 className="mb-4 mt-7 text-sm font-black uppercase tracking-[0.08em] text-[#163b3b]">
                Follow
              </h3>

              <div className="flex flex-wrap gap-3">
                {socialLinks.map(social => {
                const Icon = social.icon;
                return <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer" aria-label={`PDA Australia on ${social.label}`} className="grid h-12 w-12 place-items-center rounded-2xl border border-[#6f8f75]/25 bg-[#edf4ec] text-[#163b3b] transition hover:-translate-y-0.5 hover:bg-[#163b3b] hover:text-white hover:shadow-[0_12px_22px_rgba(22,59,59,0.18)]">
                      <Icon className="h-5 w-5" strokeWidth={2} />
                    </a>;
              })}

                <a href="https://x.com/pdaaustraliaau" target="_blank" rel="noopener noreferrer" aria-label="PDA Australia on X" className="grid h-12 w-12 place-items-center rounded-2xl border border-[#6f8f75]/25 bg-[#edf4ec] text-sm font-black text-[#163b3b] transition hover:-translate-y-0.5 hover:bg-[#163b3b] hover:text-white hover:shadow-[0_12px_22px_rgba(22,59,59,0.18)]">
                  X
                </a>
              </div>
            </nav>
          </div>

          {/* Bottom strip */}
          <div className="flex flex-col gap-3 border-t border-[#163b3b]/15 bg-gradient-to-b from-[#6f8f75]/10 to-[#e8d7bd]/20 px-6 py-6 text-xs leading-relaxed text-[#63706b] md:flex-row md:items-start md:justify-between md:px-10">
            <p className="m-0">
              <strong className="text-[#163b3b]">
                &copy; {currentYear} PDA Australia.
              </strong>
              <br />
              Free resources and downloadable guides for Australian PDA and
              autism support.
            </p>

            <p className="m-0 max-w-2xl md:text-right">
              Information on this website is general educational information
              only and does not replace medical, psychological, legal, financial
              or individual NDIS advice.
            </p>
          </div>
        </section>
      </div>
    </footer>;
}